/* eslint-disable @typescript-eslint/no-require-imports,@typescript-eslint/no-var-requires */

export const IllusDietaryRestrictions = require('./Illus-DietaryRestrictions.png');
